if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // Bind methods once to avoid creating new functions each time
        this.boundNavigatePrev = () => this.navigateMedia('prev');
        this.boundNavigateNext = () => this.navigateMedia('next');
        this.navButtons = null;
        this.isNavigating = false;
      }

      initializeNavigation() {
  // Check if arrows are enabled via data attribute
  const enableArrows = this.getAttribute('data-enable-arrows') === 'true';
  if (!enableArrows) return;
  
  // Only create buttons once per instance
  if (this.navButtons) return;


        const modalContent = this.querySelector('.product-media-modal__content');
        if (!modalContent) return;

        // Create prev button
        const prevButton = document.createElement('button');
        prevButton.className = 'product-modal__nav product-modal__nav--prev';
        prevButton.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="#6b7177" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        prevButton.setAttribute('aria-label', 'Previous image');
        prevButton.style.cssText = 'position: fixed !important; left: 14px !important; top: 50% !important; top: 50svh !important; transform: translateY(-50%) !important; z-index: 102 !important; background: #eeeee9 !important; width: 40px !important; height: 40px !important; border-radius: 50% !important; border: none !important; display: none !important; align-items: center !important; justify-content: center !important; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important; cursor: pointer !important; transition: opacity 0.2s !important;';
        
        // Create next button
        const nextButton = document.createElement('button');
        nextButton.className = 'product-modal__nav product-modal__nav--next';
        nextButton.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="#6b7177" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        nextButton.setAttribute('aria-label', 'Next image');
        nextButton.style.cssText = 'position: fixed !important; right: 14px !important; top: 50% !important; top: 50svh !important; transform: translateY(-50%) !important; z-index: 102 !important; background: #eeeee9 !important; width: 40px !important; height: 40px !important; border-radius: 50% !important; border: none !important; display: none !important; align-items: center !important; justify-content: center !important; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important; cursor: pointer !important; transition: opacity 0.2s !important;';

        // Append to body
        document.body.appendChild(prevButton);
        document.body.appendChild(nextButton);

        // Add event listeners using bound methods
        prevButton.addEventListener('click', this.boundNavigatePrev);
        nextButton.addEventListener('click', this.boundNavigateNext);

        // Store references
        this.navButtons = { prevButton, nextButton };
      }

      navigateMedia(direction) {
        // Prevent rapid clicking
        if (this.isNavigating) return;
        this.isNavigating = true;

        const allMediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        const visibleMediaItems = allMediaItems.filter(item => !item.classList.contains('hide-image'));
        const currentMedia = this.querySelector('[data-media-id].active');
        
        if (!currentMedia || visibleMediaItems.length <= 1) {
          this.isNavigating = false;
          return;
        }
        
        const currentIndex = visibleMediaItems.indexOf(currentMedia);

        let nextIndex;
        if (direction === 'next') {
          nextIndex = (currentIndex + 1) % visibleMediaItems.length;
        } else {
          nextIndex = (currentIndex - 1 + visibleMediaItems.length) % visibleMediaItems.length;
        }

        const nextMedia = visibleMediaItems[nextIndex];
        if (nextMedia) {
          currentMedia.classList.remove('active');
          nextMedia.classList.add('active');
          nextMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

          const template = nextMedia.querySelector('template');
          if (nextMedia.nodeName === 'DEFERRED-MEDIA' && template?.content?.querySelector('.js-youtube')) {
            nextMedia.loadContent();
          }
        }

        // Allow next click after animation
        setTimeout(() => {
          this.isNavigating = false;
        }, 300);
      }

      hide() {
        super.hide();
        // Hide navigation buttons
        if (this.navButtons) {
          this.navButtons.prevButton.style.display = 'none';
          this.navButtons.nextButton.style.display = 'none';
        }
      }

      show(opener) {
  super.show(opener);
  this.showActiveMedia();
  
  // Check if arrows are enabled
  const enableArrows = this.getAttribute('data-enable-arrows') === 'true';
  if (!enableArrows) return;
  
  // Initialize navigation on first show
  this.initializeNavigation();

  
        // Show navigation buttons only if there are multiple images
        if (this.navButtons) {
          const visibleMediaItems = Array.from(this.querySelectorAll('[data-media-id]')).filter(item => !item.classList.contains('hide-image'));
          if (visibleMediaItems.length > 1) {
            this.navButtons.prevButton.style.display = 'flex';
            this.navButtons.nextButton.style.display = 'flex';
          }
        }
      }

      showActiveMedia() {
        // Add safety check for openedBy
        if (!this.openedBy) {
          console.warn('ProductModal: openedBy is not defined');
          return;
        }

        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) {
          console.warn('ProductModal: No media-id found on opener');
          return;
        }

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) {
          console.warn('ProductModal: Active media not found');
          return;
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      disconnectedCallback() {
        // Properly clean up event listeners and DOM elements
        if (this.navButtons) {
          // Remove event listeners first
          this.navButtons.prevButton.removeEventListener('click', this.boundNavigatePrev);
          this.navButtons.nextButton.removeEventListener('click', this.boundNavigateNext);
          
          // Remove from DOM
          this.navButtons.prevButton.remove();
          this.navButtons.nextButton.remove();
          
          // Clear references
          this.navButtons = null;
        }
      }
    }
  );
}
